import React, { useState } from "react";

import { Grid } from "@mui/material";

const SidenavContext = React.createContext();

export function SidenavWrapper({
  children,
  Component,
  defaultExpanded = null
}) {
  const [expanded, setExpandedState] = useState(
    defaultExpanded || localStorage.getItem("expanded") === "true"
  );
  function setExpanded(val) {
    setExpandedState(val);
    localStorage.setItem("expanded", val);
  }
  return (
    <SidenavContext.Provider
      value={{
        expanded,
        setExpanded
      }}
    >
      <Grid container style={{ width: "100%" }}>
        <Grid>
          <Component setExpanded={setExpanded} expanded={expanded} />
        </Grid>
        <Grid size="grow">{children}</Grid>
      </Grid>
    </SidenavContext.Provider>
  );
}

export default SidenavContext;
